import Vue from "vue"; // eslint-disable-line import/no-extraneous-dependencies

import Vuetify from "@mariobuikhuizen/vuetify";
import "@mariobuikhuizen/vuetify/dist/vuetify.min.css";
Vue.use(Vuetify);
export default new Vuetify();
export { Vue, Vuetify };